module.exports = __webpack_public_path__ + "static/media/path07.ec2b33ec.png";